var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_150404",
    "data-name": "Group 150404",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140890",
    "data-name": "Group 140890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    fill: "#dbe448",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(11.937 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369581",
    "data-name": "Path 369581",
    d: "M10.5,20.581,16.081,15l5.581,5.581",
    transform: "translate(-10.5 -15)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369582",
    "data-name": "Path 369582",
    d: "M18,4.5V17.895",
    transform: "translate(-12.419 -4.5)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpward);
export default __webpack_public_path__ + "static/media/Upward.5ceaa2b8178c8f3f83037e53a114e3c0.svg";
export { ForwardRef as ReactComponent };